import { mapGetters } from 'vuex';
import MakeupDayForm from '../widgets/MakeupDayForm';
export default {
  name: 'MakeupDayLink',
  data() {
    return {
      show: false
    };
  },
  methods: {
    onSubmit() {
      this.show = true;
    },
    onSuccess(result) {
      if (result) {
        this.$store.commit('profile/setProjectLink', result.project.link);
      }
    },
    onFailure(error) {
      console.log('The link failed to update:', error);
    }
  },
  computed: {
    ...mapGetters('profile', ['profile', 'project'])
  },
  components: {
    MakeupDayForm
  }
};